export function romanNum(num) {
    const romanNumeral = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']
    return romanNumeral[num - 1]
}

export function getCurrentDateFormatted() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-11, so we add 1
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function formatDateString(originalFormat) {
    const date = new Date(originalFormat);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function formatDateTimeLocalDate(isoDate){
    const date = new Date(isoDate);

    // Convert to UTC+7
    const utc7Date = new Date(date.getTime() + 7 * 60 * 60 * 1000);
  
    // Format to YYYY-MM-DD HH:MM:SS
    const year = utc7Date.getUTCFullYear();
    const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(utc7Date.getUTCDate()).padStart(2, '0');
    const hours = String(utc7Date.getUTCHours()).padStart(2, '0');
    const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utc7Date.getUTCSeconds()).padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;    
}

export function formatDateTimeLocalDateOnly(isoDate){
    const date = new Date(isoDate);

    // Convert to UTC+7
    const utc7Date = new Date(date.getTime() + 7 * 60 * 60 * 1000);
  
    // Format to YYYY-MM-DD HH:MM:SS
    const year = utc7Date.getUTCFullYear();
    const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(utc7Date.getUTCDate()).padStart(2, '0');
    const hours = String(utc7Date.getUTCHours()).padStart(2, '0');
    const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utc7Date.getUTCSeconds()).padStart(2, '0');
  
    return `${year}${month}${day}${hours}${minutes}${seconds}`;    
}

export function formatDateStringDateFirst(originalFormat) {
    const date = new Date(originalFormat);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}-${month}-${year}`;
}

export function formatDateStringLocalDate(originalFormat) {
    const date = new Date(originalFormat);
    const options = { year: "numeric", month: "long", day: "numeric" };
    let formattedDate = date.toLocaleDateString("en-US", options);

    // Add suffix for the day (st, nd, rd, th)
    const day = date.getDate();
    // const suffix =
    //     day === 1 || day === 21 || day === 31
    //         ? "st"
    //         : day === 2 || day === 22
    //             ? "nd"
    //             : day === 3 || day === 23
    //                 ? "rd"
    //                 : "th";

    return formattedDate.replace(/\d+/, day);
}

export function formatDateStringLocalDateINA(originalFormat) {
    const date = new Date(originalFormat);
    const options = { year: "numeric", month: "long", day: "numeric" };
    let formattedDate = date.toLocaleDateString("id-ID", options);

    // Add suffix for the day (st, nd, rd, th)
    const day = date.getDate();
    // const suffix =
    //     day === 1 || day === 21 || day === 31
    //         ? "st"
    //         : day === 2 || day === 22
    //             ? "nd"
    //             : day === 3 || day === 23
    //                 ? "rd"
    //                 : "th";

    return formattedDate.replace(/\d+/, day);
}

export function numberToWords(num) {
    const ones = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const teens = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const tens = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const thousands = ["", "Ribu", "Juta", "Miliar", "Triliun"];

    if (num === 0) return "Nol";

    let words = "";

    const convert = (n, idx) => {
        if (n === 0) return "";
        if (n < 10) return ones[n] + " " + thousands[idx];
        if (n < 20) return teens[n - 10] + " " + thousands[idx];
        if (n < 100) return tens[Math.floor(n / 10)] + " " + ones[n % 10] + " " + thousands[idx];

        let hundred = Math.floor(n / 100);
        let remainder = n % 100;
        let hundredText = hundred === 1 ? "Seratus" : ones[hundred] + " Ratus";
        return hundredText + " " + convert(remainder, idx);
    };

    let numStr = num.toString();
    let chunkCount = 0;

    while (numStr.length > 0) {
        let chunk = parseInt(numStr.slice(-3)) || 0;
        numStr = numStr.slice(0, -3);

        if (chunk) {
            let chunkText = convert(chunk, chunkCount);
            words = chunkText + " " + words;
        }
        chunkCount++;
    }

    return words.trim();
}

export function formatRupiah(number){
    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 2, // Menampilkan dua digit desimal
      }).format(number);
}

export function formatNumber(number){
    return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
}

export function formatNumberUSFormat(number) {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);
}

export function capitalizeFirstLetter(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getCurrentDateTimeFormatted(){
    const date = new Date();

    // Convert to UTC+7
    const utc7Date = new Date(date.getTime() + 7 * 60 * 60 * 1000);
  
    // Format to YYYY-MM-DD HH:MM:SS
    const year = utc7Date.getUTCFullYear();
    const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(utc7Date.getUTCDate()).padStart(2, '0');
    const hours = String(utc7Date.getUTCHours()).padStart(2, '0');
    const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utc7Date.getUTCSeconds()).padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;    
}

export function getCurrentDateTimeFormattedPlusNDays(plusDays){
    const date = new Date();

    const plusNDays = new Date(date.getTime() + (plusDays * 24 * 60 * 60 * 1000));

    // Convert to UTC+7
    const utc7Date = new Date(plusNDays.getTime() + (7 * 60 * 60 * 1000));
  
    // Format to YYYY-MM-DD HH:MM:SS
    const year = utc7Date.getUTCFullYear();
    const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(utc7Date.getUTCDate()).padStart(2, '0');
    const hours = String(utc7Date.getUTCHours()).padStart(2, '0');
    const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utc7Date.getUTCSeconds()).padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;    
}

export function getCurrentDateTimeFormattedOnly(){
    const date = new Date();

    // Convert to UTC+7
    const utc7Date = new Date(date.getTime() + 7 * 60 * 60 * 1000);
  
    // Format to YYYY-MM-DD HH:MM:SS
    const year = utc7Date.getUTCFullYear();
    const month = String(utc7Date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(utc7Date.getUTCDate()).padStart(2, '0');
    const hours = String(utc7Date.getUTCHours()).padStart(2, '0');
    const minutes = String(utc7Date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(utc7Date.getUTCSeconds()).padStart(2, '0');
  
    return `${year}${month}${day}${hours}${minutes}${seconds}`;    
}